import { ShieldCheck, Radio, Building2 } from "lucide-react";
import { SlideHeader, Headline, Body, InfoBoxGrid, DeepDive, SiteLink } from "../shared";

export function Slide09Defensibility() {
  const BOXES = [
    { title: "Issued", body: "3 utility patents (2022, 2023, 2025) and 1 design patent (2023).", icon: ShieldCheck },
    { title: "Issued Sensor Claim", body: "Claim 13 of US 12,285,084 covers the dispensing apparatus with at least one body sensor, such as heart rate, sweat or body temperature.", icon: Radio },
    { title: "Described in the Family", body: "Dual reservoirs, phone-attached versions, displays, processors, alerts and connectivity.", icon: Building2 },
  ];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-defensibility">
      <SlideHeader n="10" label="Defensibility" />
      <Headline>
        The hard part is <span className="text-accent">already patented.</span>
      </Headline>
      <Body>
        An issued U.S. patent family covers refillable wearable dispensing, including a claim
        that pairs body sensing with the dispenser.
      </Body>
      <InfoBoxGrid testid="pitch-defensibility-boxes" boxes={BOXES} />
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-5">
        Source: wearspray.com/patents. Plain-language summary; claim scope is defined by the patents.
      </p>
      <div className="mt-5">
        <DeepDive testid="defensibility" title="The Track Record">
          <div className="rounded-lg overflow-hidden border border-zinc-800 bg-black">
            <img src="/patents/certificate.png" alt="WearSpray U.S. patent certificate" className="w-full object-contain" />
          </div>
          <p className="font-body text-white text-sm font-medium mt-5">Expanding Platform IP</p>
          <div className="space-y-2 mt-2">
            {[
              "Dual reservoir configurations for carrying more than one formulation at once.",
              "Wearable device form factor configurations beyond the original wristband.",
              "Sensor integrated wearable configurations for the next generation platform.",
              "Delivery of liquids, lotions, gels and mists from the same dispensing core.",
            ].map((t) => (
              <div key={t} className="flex items-start gap-2.5">
                <span className="w-1 h-1 rounded-full bg-accent mt-2 shrink-0" />
                <p className="font-body text-zinc-400 text-sm leading-relaxed">{t}</p>
              </div>
            ))}
          </div>
          <SiteLink href="https://wearspray.com/patents">View the full patent gallery on wearspray.com</SiteLink>
        </DeepDive>
      </div>
    </div>
  );
}
